import { z } from "zod";
import { authenticatedUserSchema, responseSchema } from "./auth.schemas";

// Login API
export const loginMutationRequestSchema = z.object({
	username: z.string(),
	password: z.string(),
});

/**
 * @description Successfully authenticated user
 */
export const login200Schema = z.object({
	message: z.coerce.string(),
	success: z.coerce
		.string()
		.transform((val) => val === "true" || val === "1")
		.refine((val) => typeof val === "boolean", {
			message:
				"Query param must be 'true' or '1', otherwise it will default to false",
		}),
	token: z.string(),
	user: authenticatedUserSchema,
});

/**
 * @description Bad request
 */
export const login400Schema = z.lazy(() => responseSchema);

/**
 * @description Unauthorized - Invalid credentials
 */
export const login401Schema = z.lazy(() => responseSchema);

/**
 * @description Internal server error
 */
export const login500Schema = z.lazy(() => responseSchema);

export const loginMutationResponseSchema = z.lazy(() => login200Schema);

// Logout API
/**
 * @description Successfully logged out
 */
export const logout200Schema = z.object({
	message: z.coerce.string(),
	success: z.coerce
		.string()
		.transform((val) => val === "true" || val === "1")
		.refine((val) => typeof val === "boolean", {
			message:
				"Query param must be 'true' or '1', otherwise it will default to false",
		}),
});

/**
 * @description Internal server error
 */
export const logout500Schema = z.lazy(() => responseSchema);

export const logoutMutationResponseSchema = z.lazy(() => logout200Schema);

// Get Session API
/**
 * @description Successfully retrieved session
 */
export const getSession200Schema = z.object({
	status: z.object({
		isAuthenticated: z.boolean(),
		user: authenticatedUserSchema.optional(),
	}),
});

/**
 * @description Internal server error
 */
export const getSession500Schema = z.lazy(() => responseSchema);

export const getSessionQueryResponseSchema = z.lazy(() => getSession200Schema);
